<template>
	<div>
		<navTitle ><div class="pageTitle">筛选结果</div></navTitle>
		<div class="tagList flex flex-align-center">
			<div class="flex-1 flex flex-align-center flex-wrap">
				<div class="tag" v-if="province">{{province + reqData.city}}</div>
				<div class="tag" v-if="major_name">{{major_name}}</div>
				<div class="tag" v-if="identity_text">{{identity_text}}</div>
				<div class="tag" v-if="reqData.authentication">{{reqData.authentication == 1 ? '名师认证' : '考官认证'}}</div>
			</div>
			<div @click="$router.replace({'name': 'member_search'})" class="reSearch flex flex-align-center">
				<img src="@/static/images/my/search2.png" alt="">
				<div class="">重新搜</div>
			</div>
		</div>
		
		<div class="searchText">
			筛选结果如下：
		</div>
		
		
		<div class="memberCardList">
			<van-list
				v-model="loading"
				:finished="finished"
				finished-text="没有更多了"
				@load="onLoad"
			>
				<div class="memberCard flex flex-align-center" v-for="(item, index) in dataList" :key="index">
					<div class="avatar flex flex-align-center flex-jus-center"><img :src="item.avatar" alt="" /></div>
					<div class="info flex-1 flex flex-column flex-jus-around">
						<div class="name flex flex-align-center">
							<div>{{item.truename}}</div>
							<div>
								<img v-if="item.is_vip == 1" src="@/static/images/my/memberIDF.png" class="memberIDF1" />
								<img v-if="item.is_teacher_certification == 1" src="@/static/images/index/certImg2.png" class="memberIDF1" />
								<img v-if="item.is_examiner_certification == 1" src="@/static/images/index/certImg3.png" class="memberIDF1" />
							</div>
						</div>
						<div class="tips flex flex-align-center">
							<div>{{item.city}}</div>
							<div class="line">|</div>
							<div>{{item.sex == 1 ? '男' : '女'}}</div>
							<div class="line">|</div>
							<div v-if="item.major">{{item.major.join('、')}}</div>
						</div>
					</div>
					<div @click="follow(item.user_id, item.is_follow)" v-if="item.is_follow == 1" class="attentionBtn_no"></div>
					<div @click="follow(item.user_id, item.is_follow)" v-if="item.is_follow == 0" class="attentionBtn_yes"></div>
				</div>
			</van-list>
		</div>
	
		<div class="returnBtn" @click="$router.replace({'name': 'member_search'})">
			返回会员名片列表
		</div>
	
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				loading: false,
				finished: false,
				reqData: {
					initials: '',
					city: '',
					major_id: '',
					identity_id: '',
					authentication: '',
					page: 1,
					pageSize: 10
				},
				dataList: [],
				province: '',
				major_name: '',
				identity_text: ''
			}
		},
		created() {
			this.reqData = {...this.reqData, ...JSON.parse(this.$route.query.reqData)}
			this.province = this.$route.query.province
			this.major_name = this.$route.query.major_name
			this.identity_text = this.$route.query.identity_text
			this.getList()
		},
		mounted() {
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			getList() {
				this.$get('api/user/queryVipApply', this.reqData).then(res => {
					this.loading = false;
					let rows = res.data;
					if (rows == null || rows.length === 0) {
						this.finished = true;
						return;
					}
					this.dataList = this.dataList.concat(rows);

				})
			},
			onLoad() {
				this.reqData.page++;
				if (this.reqData.page > 1) {
					this.getList();
				}
			},
			follow(to_id, is_follow) {
				this.$post('api/circle/userFollow', {to_id}).then(res => {
					if (is_follow == 1) {
						this.$toast('已取关')
					} else {
						this.$toast('关注成功')
					}
					this.reqData.page = 1
					this.dataList = []
					this.getList()
				})
			}
		}
	}
</script>

<style scoped lang="stylus">
.returnBtn
	width 376px
	height 92px
	line-height 92px
	text-align center
	background-image url('~@/static/images/index/btnBG.png')
	background-size 100% 100%
	background-position center
	font-size: 32px;
	color: #FFFFFF;
	margin 0 auto
	margin-top 80px
.searchText
	padding-left 30px
	width 100%
	font-size: 26px;
	font-weight: bold;
	color: #000000;
.tagList
	padding 36px 30px 40px 30px
	.tag
		padding 6px 22px
		height: 52px;
		border: 2px solid #DE113C;
		border-radius: 26px;
		font-size: 28px;
		color: #DE113C;
		margin-right 24px
		margin-bottom 10px
	.reSearch
		margin-left 10px
		width: 160px;
		height: 52px;
		background: #DE113C;
		border-radius: 26px;
		padding 10px 24px
		font-size: 24px;
		color: #FFFFFF;
		img
			width 26px
			height 26px
			margin-right 12px
.memberCardList
	padding 28px 64px 6px 30px
	max-height calc(100vh - 540px)
	overflow-y auto
.memberCard
	width 100%
	height 208px
	border-radius 20px
	background-image url('~@/static/images/my/memberCardBG.png')
	background-size 100% 100%
	background-position center
	padding 42px 36px
	margin-bottom 28px
	.avatar
		width 120px
		height 120px
		background-image url('~@/static/images/my/avatarBG2.png')
		background-size 100% 100%
		background-position center
		margin-right 18px
		img
			width 90px
			height 90px
			border-radius 50%
	.info
		height 100%
	.name
		font-size 32px
		font-weight 800
		color #9A7145
		.memberIDF1
			width 32px
			height 32px
			margin-left 12px
	.tips
		// margin-top 18px
		font-size 24px
		color #C1986B
		.line
			margin-left 8px
			margin-right 8px
	.attentionBtn_yes
		align-self flex-start
		margin-top 16px
		width 132px
		height 54px
		background-size 100% 100%
		background-position center
		background-image url('~@/static/images/my/attention_yes.png')
	.attentionBtn_no
		align-self flex-start
		margin-top 16px
		width 132px
		height 54px
		background-size 100% 100%
		background-position center
		background-image url('~@/static/images/my/attention_no.png')
</style>
